<template lang="pug">
nav.menu(:class="{ 'is-active': isMenuOpen }")
  .menu-button(@click.prevent.stop="setMenuOpen(!isMenuOpen)")
    MenuIcon
  .menu-pin
  .menu-container.is-uppercase
    .menu-top-pod(v-if="this.$store.state.address")
      p(style="padding: 0 10px") Your current location
      p(
        style="display: flex; justify-items: center; align-items: center; padding: 0 10px"
      )
        fa-icon.has-text-primary(
          icon="map-marker-alt",
          size="2x",
          fixed-width,
          style="margin-right: 5px"
        )
        span.has-text-primary {{ this.$store.state.builtAddress }}
    .menu-pod(style="background-color: #8bcce5")
      router-link(to="/")
        fa-icon(icon="search", size="2x", fixed-width)
        span Search
    .menu-pod(style="background: #79d8ff")
      a(href="https://my.cybersmart.co.za")
        fa-icon(icon="caret-right", size="2x", fixed-width)
        span Connectivity Portal
    .menu-pod(style="background: #79d8ff")
      a(href="https://shop.cybersmart.co.za/shop", target="_blank")
        fa-icon(icon="shopping-cart", size="2x", fixed-width)
        span Shop Now
    .menu-pod(style="background: #00b5ff")
      router-link(to="/contact-us")
        fa-icon(icon="phone-alt", size="2x", fixed-width)
        span Contact us
    .menu-pod(style="background-color: #21a2dc")
      router-link(to="/notices")
        fa-icon(icon="wifi", size="2x", fixed-width)
        span Network Status
    .menu-pod(style="background-color: #006fc2")
      a(href="https://help.cybersmart.co.za")
        fa-icon(icon="question-circle", size="2x", fixed-width)
        span HELP
    .menu-pod(style="background-color: #0039ab")
      a(href="https://hosting.cybersmart.co.za/")
        fa-icon(icon="server", size="2x", fixed-width)
        span Hosting
    .menu-pod(style="background: #01489d")
      router-link(to="/about")
        fa-icon(icon="users", size="2x", fixed-width)
        span About Us
    .menu-pod(style="background: #01489d")
      a(href="https://mailer.cybersmart.co.za/webmail")
        fa-icon(icon="caret-right", size="2x", fixed-width)
        span Webmail
    .menu-pod.show-more
      a(href="#", @click.prevent.stop="showMore = !showMore")
        strong Show {{ showMore ? 'Less' : 'More' }} Items
        fa-icon(:icon="showMore ? 'chevron-up' : 'chevron-down'", fixed-width)

    template(v-if="showMore")
      .menu-pod(style="background-color: #8bcce5")
        router-link(to="/blog")
          fa-icon(icon="newspaper", size="2x", fixed-width)
          span NEWS
      .menu-pod(style="background-color: #8bcce5")
        router-link(to="/legal")
          fa-icon(icon="balance-scale", size="2x", fixed-width)
          span Legal
</template>

<script>
import MenuIcon from "@/inline-svg/menu.svg";

export default {
  components: { MenuIcon },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    isMenuOpen() {
      return this.$store.getters.getMenuOpen;
    },
  },
  methods: {
    setMenuOpen(val) {
      this.$store.commit("setMenuOpen", val);
    },
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables.sass";
@import "../styles/variables";
@import "~bulma";

.menu {
  user-select: none;
  margin-right: -1rem;

  .menu-button {
    width: 4rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    border: none;
    background-color: #fff;
    color: $primary-colour;
    cursor: pointer;

    transition: background-color 300ms, color 300ms, box-shadow 300ms;
    svg {
      pointer-events: none;
    }
  }

  .menu-pin {
    display: block;
    opacity: 0;
    position: absolute;
    height: 4rem;
    width: 4rem;
    background-color: #f2f2f2;
    transform: rotateZ(45deg);
    pointer-events: none;
    margin-top: 1rem;
  }

  .menu-container {
    opacity: 0;
    position: absolute;
    right: 1rem;
    background: #f2f2f2;
    z-index: 5;
    color: #fff;
    font-size: 0.75rem;
    margin-top: 5px;
    pointer-events: none;
    transition: opacity 300ms;

    @include from($desktop) {
      width: 18.25rem;
    }

    .menu-top-pod,
    .menu-bottom-pod {
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      padding: 0.5rem 0;
      height: 4rem;
      object {
        margin-right: 4px;
        pointer-events: none;
      }
    }

    .menu-top-pod {
      color: #2c3e50;
      flex-direction: column;
      height: 6rem;
    }

    .menu-pod {
      margin: 5px;

      a {
        display: flex;
        align-items: center;
        flex-direction: row;
        padding: 10px 15px;
        color: #fff !important;

        svg {
          display: inline;
          margin-right: 10px;
        }
      }

      &.show-more {
        a {
          background-color: #fff;
          color: #01a5e8 !important;

          svg {
            margin-left: auto;
            margin-right: unset;
          }
        }
      }
    }
  }

  &.is-active {
    .menu-button {
      background-color: #01a5e8;
      color: #fff;
      box-shadow: 0 0 2px 2px #e0e0e0e0;
    }

    .menu-pin {
      opacity: 1;
      margin-top: 0;
      transition: opacity 0ms 300ms,
        margin-top 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    }

    .menu-container {
      opacity: 1;
      pointer-events: unset;
    }
  }

  @include until($tablet) {
    .menu-container {
      left: 1rem;
    }
  }
}
</style>
